import SectionHeading from "./SectionHeading";

const steps = [
  { no: "01", title: "先看留白", desc: "正文之外那些语焉不详、一笔带过的位置，往往是信息密度最高的地方。先标出来，再谈理解。" },
  { no: "02", title: "再找节点", desc: "把时间戳、工商变更、公告口径等硬信息当作节点，按真实先后顺序重新排列，而不是按新闻出现顺序。" },
  { no: "03", title: "最后连线", desc: "节点之间未必有官方说明，但公开逻辑会留下痕迹。连线时要标注依据，区分『事实』与『推断』。" },
  { no: "04", title: "分级标注", desc: "输出统一分为高置信、需验证与线索池三级。状态会随证据变化实时更新，绝不固化结论。" },
];

export default function Analysis() {
  return (
    <section id="analysis" className="scroll-mt-16 bg-background-100 py-12 md:py-16">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <SectionHeading
          index="06"
          eyebrow="Method"
          title="深层解析"
          desc="深度不是结论的堆叠，而是一套可以复用的拆解顺序。把这套框架交给读者，让每个人都能自己验证、自己判断。"
        />

        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {steps.map((s) => (
            <div key={s.no} className="relative flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 p-5">
              <span className="absolute -right-2 -top-4 font-heading text-7xl font-black text-primary-500/10">
                {s.no}
              </span>
              <span className="grid h-10 w-10 place-items-center rounded-md bg-primary-500 font-heading text-sm font-black text-background-50">
                {s.no}
              </span>
              <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">{s.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{s.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-5 flex flex-col items-start gap-4 rounded-lg bg-foreground-950 p-6 md:flex-row md:items-center md:justify-between md:p-7">
          <div className="flex items-start gap-3">
            <span className="mt-1 grid h-9 w-9 shrink-0 place-items-center rounded-md bg-accent-500 text-background-950">
              <i className="ri-quill-pen-line" />
            </span>
            <div>
              <p className="font-heading text-base font-bold text-background-50">一套方法，一个栏目</p>
              <p className="mt-1 max-w-xl text-sm leading-relaxed text-background-200/80">
                想先上手体验这套拆解框架？从《方法论：五分钟从公开信息里找出那个关键节点》开始读最合适。
              </p>
            </div>
          </div>
          <a
            href="#columns"
            className="inline-flex shrink-0 items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-5 py-2.5 text-sm font-semibold text-background-950 transition-colors hover:bg-accent-600"
          >
            查看方法论
            <i className="ri-arrow-right-line" />
          </a>
        </div>
      </div>
    </section>
  );
}